@if (content()) {
  <section>
    <h1 class="font-headline-small">
      <div class="nordic-blue-900-text text-icon-primary light-type font-body-medium">
        {{ 'flightsTo' | finLocalization }}
      </div>
      <div class="nordic-blue-900-text text-icon-primary font-headline-medium">
        {{ content().title }}
      </div>
    </h1>
    @if (content().detailText) {
      <div class="ms-medium-y" [innerHTML]="content().detailText"></div>
    }
  </section>
}
